<template>
  <div
    class="input-wrapper all-day-wrapper position-relative no-ptb"
    v-if="phoneLocal.length < 12 && !showFull"
    ref="focusableDiv"
    @click="enableShowBasicInputs"
  >
    <span class="capitalize" :class="{ 'show-half': !showFull }">Phone</span>
    <!-- Main input and select -->
    <div class="pl-100 all-phone-info">
      <!-- Input -->
      <input
        v-model="phoneLocal"
        :class="{ 'only-hide': !showBasicInputs }"
        @input="setPhoneLocal"
        @focus="showExtras = true"
        @keypress.enter="showFull = true"
        @blur="handleBlur"
        type="tel"
        placeholder
        class="title pb-0 font-16"
        ref="focusThis"
      />

      <!--Radios-->
      <div class="select-ph-option" v-show="showBasicInputs">
        <label
          class="container-radio"
          v-for="(currPhoneType, index) in allPhoneTypes"
          :key="index"
          :value="index"
          @click="setPhoneTypeLocal(index)"
        >
          <span
            class="checkmark"
            :class="{ checked: phoneType[0] === index }"
            tabindex="0"
          >
          </span>
          <span>
            {{ currPhoneType[0].toUpperCase() + currPhoneType.slice(1) }}
          </span>
        </label>
      </div>

      <!-- Select -->
      <!-- <select
        v-if="showExtras"
        class="simple-select"
        :value="phoneType[0]"
        @change="setPhoneTypeLocal($event.target.value)"
        @click.stop
      >
        <option
          v-for="(currPhoneType, index) in allPhoneTypes"
          :key="index"
          :value="index"
          >{{ currPhoneType.toUpperCase() }}</option
        >
      </select> -->

      <!-- <a
        href="#"
        class="add-ph"
        v-if="showExtras"
        @click.prevent="showFull = true"
      >
        <img src="../../../assets/img/m_plus.png" alt="Add more numbers" />
      </a> -->
    </div>
  </div>

  <div
    class="input-wrapper all-day-wrapper position-relative"
    @click.prevent="
      () => {
        preventHide = true;
        showPhonesDropDown = !showPhonesDropDown;
      }
    "
    v-else
  >
    <span class="ver-center capitalize">Phone</span>

    <div tabindex="-1" class="user-ph-list" ref="mainDiv">
      <p>
        {{ lastSelectedPhoneShow }}
        <template v-if="lastSelectedPhoneTypeShow">
          <span
            class="ver-split"
            v-if="lastSelectedPhoneShow !== 'Enter phone number'"
            >|</span
          >
          <span
            class="ph-type"
            v-if="lastSelectedPhoneShow !== 'Enter phone number'"
            >{{ lastSelectedPhoneTypeShow }}</span
          >
        </template>
        <a href="#" class="ph-dropdown" @click.prevent>
          <img src="../../../assets/img/drop-white.png" alt="Dropdown" />
        </a>
      </p>
    </div>
    <transition name="expand">
      <!-- The full drop down -->
      <div class="ph-edit-con" v-if="showPhonesDropDown" @click.stop>
        <!-- All the inner options -->
        <template v-for="n in [0, 1, 2, 3]">
          <phone-inner
            :key="n"
            :index="n"
            v-if="phone && phone.length >= n + 1"
            :set-last-selected-phone="setLastSelectedPhone"
            :hide-show-phonesd-drop-down="hideShowPhonesDropDown"
            :close-remaining-phone-type-options="closeRemainingPhoneTypeOptions"
            :close-remaining="closeRemaining"
          />
        </template>

        <!-- Add more phone option -->
        <div class="ph-info no-bor" v-if="phone.length < 4">
          <a
            href="#"
            class="ph-add"
            @click.stop.prevent="setPhone({ value: '', index: phone.length })"
          >
            <img src="../../../assets/img/m_plus.png" alt="Add" />Add Phone
          </a>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import PhoneInner from "./PhoneInner";
import { mapGetters, mapMutations } from "vuex";

export default {
  data() {
    return {
      showBasicInputs: false, // Weather to show the basic inputs
      showExtras: false,
      showPhonesDropDown: false,
      phoneLocal: "",
      preventHide: false,
      lastSelectedPhone: -1,
      dropIcon: require("../../../assets/img/drop.png"),
      showFull: false,
      timeOut: null,
      closeRemainingPhoneTypeOptions: false
    };
  },
  computed: {
    ...mapGetters({
      selectedProviderId: "getSelectedProviderID"
    }),
    ...mapGetters("clients", {
      clients: "getClients",
      editClientId: "getEditClientId"
    }),
    ...mapGetters("addNew", {
      phone: "getPhone",
      phoneType: "getPhoneType",
      allPhoneTypes: "getAllPhoneTypes"
    }),
    lastSelectedPhoneShow() {
      if (
        this.lastSelectedPhone === -1 ||
        this.phone.length <= 0 ||
        !this.phone[this.lastSelectedPhone] ||
        this.phone[this.lastSelectedPhone].length === 0
      ) {
        if (this.phone.length > 0) {
          return this.phone[0];
        }
        return "Enter phone number";
      } else {
        return this.phone[this.lastSelectedPhone];
      }
    },
    lastSelectedPhoneTypeShow() {
      if (this.lastSelectedPhone === -1) {
        if (this.phone.length > 0) {
          return this.allPhoneTypes[this.phoneType[0]].charAt(0).toUpperCase();
        }
        return false;
      } else {
        return this.allPhoneTypes[this.phoneType[this.lastSelectedPhone]]
          .charAt(0)
          .toUpperCase();
      }
    }
  },
  methods: {
    ...mapMutations("addNew", {
      setPhone: "setPhone",
      setPhoneType: "setPhoneType",
      removePhone: "removePhone"
    }),
    /**
     * Enable show inputs
     */
    enableShowBasicInputs() {
      this.showBasicInputs = true;
      if (this.$refs.focusThis) {
        this.$refs.focusThis.focus();
      }
    },
    handleBlur() {
      if (this.phoneLocal) {
        this.timeOut = setTimeout(() => {
          this.showFull = true;
        }, 200);
      }
    },
    setPhoneLocal() {
      const nums = this.phoneLocal.split("");
      let newNums = "";
      for (let i = 0; i < nums.length; i++) {
        if (!isNaN(nums[i]) && newNums.length < 12) {
          if (i !== 0 || parseInt(nums[i]) !== 0) {
            if (newNums.length === 3 || newNums.length === 7) {
              newNums += "-";
            }
            newNums += nums[i];
          }
        }
      }
      this.phoneLocal = newNums;
      this.setPhone({ value: newNums, index: 0 });
      this.setLastSelectedPhone(0);
    },
    setPhoneTypeLocal(value) {
      if (this.timeOut) {
        clearTimeout(this.timeOut);
      }
      this.setPhoneType({ value: parseInt(value), index: 0 });
      this.viewListItem = false;
    },
    setLastSelectedPhone(index) {
      if (isNaN(index) || parseInt(index) > 4 || parseInt(index) < -1) {
        return;
      }
      this.lastSelectedPhone = parseInt(index);
    },
    hideShowPhonesDropDown() {
      setTimeout(() => {
        if (this.preventHide) {
          this.preventHide = false;
          return;
        }
        this.showPhonesDropDown = false;
      });
    },
    /**
     * Close the remaining optins
     */
    closeRemaining(value) {
      this.closeRemainingPhoneTypeOptions = value;
    }
  },
  components: {
    PhoneInner
  },
  watch: {
    showFull(value) {
      if (value) {
        this.setPhone({ value: "", index: this.phone.length });
      }
    }
  },
  created() {
    if (this.editClientId === 0) {
      return;
    }
    const client = this.clients[this.selectedProviderId].find(curClient => {
      return curClient.id === this.editClientId;
    });
    for (let i = 0; i < this.phone.length; i++) {
      if (this.phone[i] === client.selected_phone) {
        this.lastSelectedPhone = i;
        return;
      }
    }
    // if (this.phone.length > 0) {
    //   this.lastSelectedPhone = 0;
    //   this.phoneLocal = this.phone[0];
    //   this.showFull = true;
    //   console.log('this.phoneLocal1');
    //   console.log(this.phoneLocal);
    // }
  },
  mounted() {
    this.$nextTick(() => {
      // Event listener for the drop down
      window.addEventListener("click", this.hideShowPhonesDropDown);
    });
    if (this.phone.length > 0) {
      this.lastSelectedPhone = 0;
      this.phoneLocal = this.phone[0];
      this.showFull = true;
    }
  },
  destroyed() {
    window.removeEventListener("click", this.hideShowPhonesDropDown);
  }
};
</script>

<style scoped>
.input-wrapper {
  background: transparent !important;
  user-select: none !important;
}

div.input-wrapper {
  display: flex;
}

.only-hide {
  opacity: 0;
  height: 5px;
}

div.all-phone-info {
  display: flex;
  flex-direction: column;
  margin-left: 30px !important;
  justify-content: space-around;
}

.hide-width {
  width: 0 !important;
}

/* Before enter */
.fade-full-enter {
  opacity: 0;
}

/* stage 2. Entered */
.fade-full-enter-active {
  transition: opacity 0.3s ease-in-out;
}

/* stage 3. leave */
.fade-full-leave-active {
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
}

.drop-icon {
  margin-bottom: 2px;
}

span.capitalize {
  text-transform: capitalize;
}

span.show-half {
  margin-top: 12px;
}

div.phone-type-selector {
  position: absolute;
  display: flex;
  top: 40px;
  background: white;
  z-index: 99999;
  box-shadow: 0px 0px 10px gray;
}

ul {
  list-style: none;
  padding: 0;
}

li {
  padding: 5px 50px;
  text-transform: capitalize;
}

.input-wrapper input {
  border: none !important;
  margin-bottom: 10px;
}

.user-ph-list {
  max-width: 270px;
  width: 100%;
  color: #000;
  background: #fff;
  padding: 0px 0 0 10px;
  border-radius: 4px;
  border: 1px solid #4089c5;
  margin: 0px 0px 0px 90px;
}

.user-ph-list p {
  line-height: 24px;
  margin: 0;
}

.sticky-header .header-icon-contain img {
  width: auto;
}

.ph-type {
  padding: 5px;
}

a.ph-dropdown {
  /* display: inline-block; */
  float: right;
  background: #4089c5;
  text-align: center;
  width: 30px;
}
a.ph-dropdown img {
  height: 7px;
}

.ph-edit-con {
  background: #fff;
  padding: 5px 10px 0 10px;
  border-radius: 5px;
  max-width: 260px;
  border: 1px solid #ccc;
  position: absolute;
  z-index: 3;
  display: block;
  margin-left: 89px;
  width: 100%;
  top: 39px;
}

.phone-input {
  margin-bottom: 8px;
}

div >>> .ph-info {
  position: relative;
  margin: 5px auto;
  border-bottom: 1px solid #ccc;
  padding-bottom: 5px;
  width: 100%;
  height: 40px;
}
.ph-info:last-child {
  border-bottom: 0;
}

div >>> .ph-info a {
  text-decoration: none;
}

div >>> .ph-info input {
  float: left;
  padding: 6px 5px;
  border: 1px solid #ccc !important;
  max-width: 130px;
}

div >>> ul.ph-types {
  list-style: none;
  margin: 0 10px;
  padding: 0;
  background: #fff;
  border: 1px solid #ccc;
  padding: 3px 5px 2px;
  width: 80px;
  position: absolute;
  left: 135px;
  z-index: 4;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
}
div >>> ul.ph-types.open {
  z-index: 5;
}

div >>> .ph-types li {
  display: none;
  padding: 0;
  border-bottom: 1px solid #ebebeb;
  font-size: 16px;
}
div >>> .ph-types li:first-child {
  border-bottom: none;
}
div >>> .ph-types li a {
  display: block;
  padding: 3px 5px;
  font-size: 14px;
  font-weight: bold;
}
div >>> .ph-types li a:hover {
  background: #ccc;
  color: #fff;
}

div >>> .ph-types li:first-child {
  display: block;
}
div >>> .ph-types li:last-child {
  border-bottom: block;
}

div >>> .ph-types-drop {
  display: inline-block;
  position: absolute;
  top: 0;
  right: 0;
  width: 15px;
  text-align: center;
  background: none !important;
}

div >>> .ph-delete,
.ph-add {
  display: inline-block;
  vertical-align: middle;
  position: absolute;
  right: 0;
}
div >>> .ph-add {
  left: 0;
  font-weight: bold;
}

div >>> .ph-delete {
  top: 5px;
}

a.ph-add img {
  margin-right: 10px;
  position: relative;
  top: 3px;
}

div >>> .ph-delete img,
.ph-add img {
  max-width: 18px;
}
.no-bor {
  border: none;
  border: 0;
}

.expand-leave-active {
  animation: contract 0.1s ease-in-out forwards;
}

.expand-enter-active {
  animation: expand 0.1s ease-in-out forwards;
}
.all-phone-info input,
.all-phone-info select,
.all-phone-info a {
  display: block;
  float: left;
}

.all-phone-info input {
  width: 100%;
  max-width: 320px;
}
.all-phone-info a.add-ph {
  position: relative;
  top: 5px;
}
.all-phone-info a.add-ph img {
  width: 18px;
  height: 18px;
  display: block;
  margin-left: 5px;
}

.all-phone-info {
  padding: 10px 15px 10px 0 !important;
}
.all-phone-info .select-ph-option {
  position: relative;
  margin: 10px 0 -10px -76px;
}
.select-ph-option .container-radio {
  background: none;
  padding-right: 12px;
  display: inline-block;
  margin-bottom: 10px;
  padding-left: 20px;
  font-size: 14px;
}

@media screen and (min-width: 321px) and (max-width: 480px) {
  .user-ph-list {
    max-width: 220px;
    float: right;
    margin-right: 10px;
  }
  #notes {
    max-width: 320px;
  }
  .ph-edit-con {
    right: 0;
  }
  .all-phone-info input {
    max-width: 140px;
  }
}

@media screen and (max-width: 320px) {
  .user-ph-list {
    max-width: 175px;
  }
  .ph-edit-con {
    right: 0;
  }
  #notes {
    max-width: 240px;
  }
  .all-phone-info input {
    max-width: 140px;
  }
  .select-ph-option .container-radio {
    padding-right: 8px;
    padding-left: 19px;
    font-size: 12px;
  }
  .select-ph-option .container-radio .checkmark.checked {
    top: -2px;
  }
}

@keyframes expand {
  from {
    opacity: 0;
    transform: translateY(-20%);
    transform: scaleY(0);
  }
  to {
    opacity: 1;
    transform: translateY(0%);
    transform: scaleY(1);
  }
}

@keyframes contract {
  from {
    opacity: 1;
    transform: scaleY(1);
  }
  to {
    opacity: 0;
    transform: scaleY(0);
  }
}
</style>
